import api from '../utils/api';

class ToursApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/tours', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAlLanguages = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/langs', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getGroup = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/tours/group');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/tours/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updatePriceCron = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/tours/tour-cron/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/tours', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  createLanguage = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/langs', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/tours/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/tours/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/tours/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/tours/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  searchOption = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/tours/search/option', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  sendIndexNow = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/tours/indexNow/send', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };
}
const tourApi = new ToursApi();
export default tourApi;
